/* Official Cal.com embed; no availability, bookings or personal data are stored in the theme. */
(function () {
  'use strict';
  if (window.bvjShowroomBookingInstalled) return;
  window.bvjShowroomBookingInstalled = true;
  var counter = 0;
  var activeCleanups = new Map();

  function installCalLoader() {
    if (typeof window.Cal === 'function') return;
    function enqueue(api, args) { api.q.push(args); }
    window.Cal = function () {
      var cal = window.Cal;
      var args = arguments;
      if (!cal.loaded) {
        cal.ns = {};
        cal.q = cal.q || [];
        var script = document.createElement('script');
        script.src = 'https://app.cal.com/embed/embed.js';
        script.async = true;
        script.addEventListener('error', function () {
          document.dispatchEvent(new Event('bvj:cal-load-error'));
        }, { once: true });
        document.head.appendChild(script);
        cal.loaded = true;
      }
      if (args[0] === 'init') {
        var api = function () { enqueue(api, arguments); };
        var namespace = args[1];
        api.q = api.q || [];
        if (typeof namespace === 'string') {
          cal.ns[namespace] = cal.ns[namespace] || api;
          enqueue(cal.ns[namespace], args);
          enqueue(cal, ['initNamespace', namespace]);
        } else {
          enqueue(cal, args);
        }
        return;
      }
      enqueue(cal, args);
    };
  }

  function initialize(root) {
    if (root.dataset.bvjInitialized === 'true') return;
    var mount = root.querySelector('[data-bvj-cal-mount]');
    var status = root.querySelector('[data-bvj-cal-status]');
    if (!mount || !status) return;
    root.dataset.bvjInitialized = 'true';
    var observer;
    var timeout;
    var started = false;
    var disposed = false;
    var namespace = 'bvjShowroom' + (++counter);

    function failed() {
      if (disposed || !root.isConnected) return;
      clearTimeout(timeout);
      mount.hidden = true;
      mount.setAttribute('aria-busy', 'false');
      status.textContent = 'De agenda kon hier niet worden geladen. Gebruik de knop hieronder om rechtstreeks een afspraak te plannen.';
      status.hidden = false;
    }
    function loaded() {
      if (disposed || !root.isConnected) return;
      clearTimeout(timeout);
      mount.hidden = false;
      mount.setAttribute('aria-busy', 'false');
      status.hidden = true;
      var frame = mount.querySelector('iframe');
      if (frame) frame.title = 'Plan je adviesgesprek bij Badkamervoorjou';
    }
    function start() {
      if (started || disposed || !root.isConnected) return;
      started = true;
      if (observer) observer.disconnect();
      mount.hidden = false;
      mount.setAttribute('aria-busy', 'true');
      status.hidden = false;
      timeout = setTimeout(failed, 20000);
      document.addEventListener('bvj:cal-load-error', failed);
      try {
        installCalLoader();
        window.Cal('init', namespace, { origin: 'https://cal.com' });
        var cal = window.Cal.ns[namespace];
        cal('on', { action: 'linkReady', callback: loaded });
        cal('on', { action: 'linkFailed', callback: failed });
        cal('inline', {
          elementOrSelector: mount,
          calLink: 'badkamervoorjou/adviesgesprek',
          config: { layout: 'month_view', theme: 'dark' }
        });
        cal('ui', {
          theme: 'dark',
          layout: 'month_view',
          hideEventTypeDetails: false,
          cssVarsPerTheme: {
            dark: {
              'cal-brand': '#e6ded3',
              'cal-brand-emphasis': '#d6c8b8',
              'cal-brand-text': '#020a12',
              'cal-text': '#ffffff',
              'cal-text-emphasis': '#ffffff',
              'cal-text-subtle': '#e6ded3',
              'cal-text-muted': '#c8c3bb',
              'cal-bg': '#020a12',
              'cal-bg-emphasis': '#1b2630',
              'cal-bg-subtle': '#111c26',
              'cal-bg-muted': '#15212c',
              'cal-border': '#46515b',
              'cal-border-subtle': '#33404b',
              'cal-border-booker': '#33404b'
            }
          }
        });
      } catch (error) {
        failed();
      }
    }
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) start();
      }, { rootMargin: '400px 0px' });
      observer.observe(root);
    } else {
      start();
    }
    activeCleanups.set(root, function () {
      disposed = true;
      clearTimeout(timeout);
      if (observer) observer.disconnect();
      document.removeEventListener('bvj:cal-load-error', failed);
      activeCleanups.delete(root);
    });
  }
  function initializeAll() {
    activeCleanups.forEach(function (cleanup, root) { if (!root.isConnected) cleanup(); });
    document.querySelectorAll('[data-bvj-booking]').forEach(initialize);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', initializeAll);
  document.addEventListener('shopify:section:unload', function (event) {
    activeCleanups.forEach(function (cleanup, root) { if (event.target.contains(root)) cleanup(); });
  });
})();
